import type { AxiosInstance } from 'axios';
import type {
	CmsSignpost,
	CmsSignpostGroup,
	CmsSignpostGroupResponse,
	CmsSignpostResponse,
} from '@gov-nx/api';
import type { LocalizationLanguage } from '@gov-nx/core/app';
import type { Designation } from '../types/designation';

export interface SignpostRequestParams {
	app: string;
	env: string;
	search?: string;
	locale: LocalizationLanguage;
	serviceGroups?: number;
	designations?: Designation;
	externalServiceLink?: string;
}

export interface SignpostGroupRequestParams {
	locale: LocalizationLanguage;
}

export const cmsSignpostQuery = async (
	axiosCmsBaseInstance: AxiosInstance,
	params: SignpostRequestParams
): Promise<CmsSignpost[]> => {
	const response = await axiosCmsBaseInstance.get<CmsSignpostResponse>(
		'/search/',
		{
			params,
		}
	);
	return response.data.data;
};

export const cmsSignpostGroupsQuery = async (
	axiosCmsInstance: AxiosInstance,
	params: SignpostGroupRequestParams
): Promise<CmsSignpostGroup[]> => {
	const response = await axiosCmsInstance.get<CmsSignpostGroupResponse>(
		`/service-groups/${params.locale}.json`
	);
	return response.data.data;
};
